import mercedes from "../assets/product-mercedes.png";
import motorcycle from "../assets/product-motorcycle.png";
import keke from "../assets/product-keke.png";
import sportsCar from "../assets/sports-car.png";

export const products = [
  {
    id: 1,
    name: "Mercedes",
    model: "E350",
    price: "$150k",
    image: mercedes,
    imgAlt: "alt-1",
    year: "2010",
    bodyType: "curvy",
    fuel: "Gasoline",
    type: "Sedan",
    vinNumber: "123456789",
    location: "lekki",
    mileage: "50,000km",
    color: "blue",
  },
  {
    id: 2,
    name: "TVS",
    model: "E350",
    price: "$150k",
    image: motorcycle,
    imgAlt: "alt-2",
    year: "2020",
    bodyType: "curvy",
    fuel: "Gasoline",
    type: "Motorcycle",
    vinNumber: "123456789",
    location: "Ajah",
    mileage: "5,000km",
    color: "blue",
  },
  {
    id: 3,
    name: "Bajaj",
    model: "E350",
    price: "$150k",
    image: keke,
    imgAlt: "alt-3",
    year: "2020",
    bodyType: "curvy",
    fuel: "Gasoline",
    type: "Tricycle",
    vinNumber: "123456789",
    location: "lekki",
    mileage: "500,000km",
    color: "green",
  },
  {
    id: 4,
    name: "mercedes",
    model: "E350",
    price: "$150k",
    image: mercedes,
    imgAlt: "alt-4",
    year: "2020",
    bodyType: "curvy",
    fuel: "Gasoline",
    type: "Sedan",
    vinNumber: "123456789",
    location: "Magodo",
    mileage: "50,000km",
    color: "brown",
  },
  {
    id: 5,
    name: "Chevrolet",
    model: "ES350",
    price: "$150k",
    image: sportsCar,
    imgAlt: "alt-5",
    year: "2015",
    bodyType: "Sporty",
    fuel: "Gasoline",
    type: "Sports Car",
    vinNumber: "123456789",
    location: "Abuja",
    mileage: "50,000km",
    color: "black",
  },
  {
    id: 6,
    name: "TVS",
    model: "E350",
    price: "$150k",
    image: motorcycle,
    imgAlt: "alt-2",
    year: "2020",
    bodyType: "curvy",
    fuel: "Gasoline",
    type: "Motorcycle",
    vinNumber: "123456789",
    location: "Alagbado",
    mileage: "50,000km",
    color: "Grey",
  },
  {
    id: 7,
    name: "Bajaj",
    model: "E350",
    price: "$150k",
    image: keke,
    imgAlt: "alt-3",
    year: "2020",
    bodyType: "curvy",
    fuel: "Gasoline",
    type: "Tricycle",
    vinNumber: "123456789",
    location: "lekki phase 1",
    mileage: "50,000km",
    color: "orange",
  },
  {
    id: 8,
    name: "mercedes",
    model: "E350",
    price: "$150k",
    image: mercedes,
    imgAlt: "alt-4",
    year: "2020",
    bodyType: "curvy",
    fuel: "Gasoline",
    type: "Sedan",
    vinNumber: "123456789",
    location: "Allen",
    mileage: "50,000km",
    color: "matt black",
  },
  {
    id: 9,
    name: "Chevrolet",
    model: "ES350",
    price: "$150k",
    image: sportsCar,
    imgAlt: "alt-5",
    year: "2015",
    bodyType: "Sporty",
    fuel: "Gasoline",
    type: "Sports Car",
    vinNumber: "123456789",
    location: "lekki",
    mileage: "20,000km",
    color: "Yellow",
  },
];

export const users = [
  {
    id: 1,
    firstName: "Ezekiel",
    lastName: "Frederick",
    email: "ezekiel@gmail.com",
    type: "seller",
  },
  {
    id: 2,
    firstName: "Cassidy",
    lastName: "Nwune",
    email: "kass.nwune@gmail.com",
    type: "buyer",
  },
];
